import CustomerDetail from './call/CustomerDetail';
import CallHandler from './call/CallHandler';
import CallTag from '../CallTag';

export { CustomerDetail, CallHandler, CallTag };



// WEBPACK FOOTER //
// src/dialpad/components/layout/components/index.js